import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Badge
} from 'reactstrap';
import moment from 'moment';
import $ from 'jquery';
import AppPage from '../../views/AppPage/'

class Events extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			eventtype : '',
			_message : '',
			alertClass :'',
			posts : [],
			_redirect : false,
			viewDirect : false,
			addDirect : false,
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onView = this.onView.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	onBack(e){
		
		this.setState({addDirect :true});
	}
	
	onView(dt){
		
		this.state.id = dt;
		this.setState({viewDirect : true});
	}
	
	onUpdate(dt){
		
		this.state.id = dt;
		this.setState({_redirect : true});
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		$("#showLoader").show();
		if (window.confirm("Do you want to Delete?")) {
				$("#showLoader").hide();
			PostData('event/deleteevent',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Event Removed Successfully',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove EventType',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
		
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.eventtype){
			$("#showLoader").show();
			PostData('event/addtype',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'EventType Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("etypeform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	componentWillMount() {
		 
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('event/getevents').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	checkedate(dat){
		
		var ed = new Date(dat);
		var momentObj = moment(ed);
		var momentString = momentObj.format('MMMM DD , Y');
		return momentString;
	}
	
	checkstatus(dat){
		
		var sta = [];
		var today = new Date();
		var edata = new Date(dat);
		 
		if(edata > today){
			 
			sta.push(<Badge className="mr-1" color="success">Pending</Badge>);
		}
		else{
			 
			sta.push(<Badge className="mr-1" color="danger">Completed</Badge>);
		}
		return sta;
	}
	
  render() {
	
	if(this.state._redirect){
		
		return (<Redirect to={'/events/editevent/' + this.state.id} />);
	}
	
	if(this.state.viewDirect){
		
		return (<Redirect to={'/events/viewevent/' + this.state.id} />);
	}
	
	if(this.state.addDirect){
		
		return (<Redirect to={'/events/addevent'} />);
	}
	
    return (
		<div>
		  <AppPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
				   <Card>
					<CardHeader>
						<strong>Events</strong>
						<Button outline color="primary" className="btn-right" onClick={this.onBack}>Add Event</Button>
					</CardHeader>
					<CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Event Date</th>
								<th>Event Time</th>
								<th>Event Title</th>
								<th>Created On</th>
								<th>Status</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.posts.map((item,i) =>
							 
								<tr key = {item}>
									<td>{i+1}</td>
									<td>{this.checkedate(item.eventdate)}</td>
									<td>{item.eventtime}</td>
									<td>{item.eventname}</td>
									<td>{this.checkedate(item.idate)}</td>
									<td>{this.checkstatus(item.eventdate)}</td>
									<td>
										<button name="view" className="btn btn-warning btn-sm" onClick={() => this.onView(item.id)} ><i className="fa fa-eye"></i></button>&nbsp;&nbsp;
										<button name="edit" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>&nbsp;&nbsp;
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>
				  
							 )}
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Events;


// WEBPACK FOOTER //
// ./src/events/Event/Events.js